import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <Link to="/" className="text-xl font-heading font-bold text-white">
                白云视频
              </Link>
              <p className="mt-3 text-sm text-background-400 leading-relaxed">
                白云视频——苹果视频、榴莲视频同款手机免费在线播放平台。高清不缓冲，随时随地畅享影视盛宴。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">
                <a href="#footer-links" className="hover:text-primary-400 transition-colors">快速链接</a>
              </h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors">首页</Link></li>
                <li><Link to="/category/hot" className="text-sm text-background-400 hover:text-primary-400 transition-colors">热门推荐</Link></li>
                <li><Link to="/category/movie" className="text-sm text-background-400 hover:text-primary-400 transition-colors">电影大片</Link></li>
                <li><Link to="/category/tv" className="text-sm text-background-400 hover:text-primary-400 transition-colors">电视剧</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">
                <a href="#footer-categories" className="hover:text-primary-400 transition-colors">内容分类</a>
              </h4>
              <ul className="space-y-2.5">
                <li><Link to="/category/anime" className="text-sm text-background-400 hover:text-primary-400 transition-colors">动漫番剧</Link></li>
                <li><Link to="/category/variety" className="text-sm text-background-400 hover:text-primary-400 transition-colors">综艺娱乐</Link></li>
                <li><Link to="/category/documentary" className="text-sm text-background-400 hover:text-primary-400 transition-colors">纪录片</Link></li>
                <li><Link to="/category/short" className="text-sm text-background-400 hover:text-primary-400 transition-colors">短剧爽片</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">
                <a href="#footer-about" className="hover:text-primary-400 transition-colors">关于我们</a>
              </h4>
              <ul className="space-y-2.5">
                <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">品牌介绍</Link></li>
                <li><a href="mailto:contact@baiyunvideo.com" className="text-sm text-background-400 hover:text-primary-400 transition-colors">联系我们</a></li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 白云视频 BaiYun Video. 保留所有权利。
            </p>
            <div className="flex items-center gap-5">
              <a href="#" className="text-background-500 hover:text-primary-400 transition-colors" aria-label="微信"><i className="ri-wechat-line text-lg"></i></a>
              <a href="#" className="text-background-500 hover:text-primary-400 transition-colors" aria-label="微博"><i className="ri-weibo-line text-lg"></i></a>
              <a href="#" className="text-background-500 hover:text-primary-400 transition-colors" aria-label="邮箱"><i className="ri-mail-line text-lg"></i></a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}